<template>
  <div class="container">
    <div class="top">
      <TopNave></TopNave>
    </div>
    <div class="under">
      <div class="left" v-show="hamburgerOpen">
        <SideNave></SideNave>
      </div>
      <div class="right">
        <div class="right-top">
          <Bread></Bread>
        </div>
        <div class="right-under">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import SideNave from "./side-nav.vue"
  import Bread from "./bread-crumb.vue"
  import TopNave from "./top-nav.vue"

  export default {
    name: "layout",
    data() {
      return {
        hamburger: true
      };
    },
    components: {
      SideNave, Bread, TopNave
    },

    computed: {
      hamburgerOpen() {
        return this.$store.state.layout.humberOpen;
      }
    },

    beforeRouteUpdate(to, from, next) {
      // let arr = to.path.split('/');
      // arr = this._.drop(arr);
      // let path = arr[1];
      // let parentPath = this._.first(arr);
      let path = '';
      // useForwardNavKey 就代表使用来源key的导航高亮
      if (to.meta.useForwardMenuKey && to.meta.useForwardMenuKey == true) {
        let arr = from.path.split('/');
        arr = this._.drop(arr);
        path = arr[0];
      } else {
        let arr = to.path.split('/');
        arr = this._.drop(arr);
        path = arr[0];
      }
      this.$store.commit("changeKey", path);
      this.cache.storeMenuKey(path);
      next();
    }
  }

</script>


<style lang="scss" type="text/scss" scoped>
  @import "../../style/public";

  .top {
    height: 68px;
    width: 100%;
    background-color: $sideDarkColor;
    position: fixed;
    z-index: 1000;
  }

  .under {
    position: absolute;
    width: 100%;
    top: 68px;
    bottom: 0;
    display: flex;
    min-width: 1200px !important;
  }

  .left {
    flex-basis: 206px;
    height: 100%;
    background-color: #2c3e50;
    flex-shrink: 0;
  }

  .right {
    height: 100%;
    background: white;
    flex-grow: 1; // display: flex;
    flex-direction: column;
    overflow-y: auto;
    /*align-items: stretch;*/
    /*overflow-x: scroll;*/
  }

  .right-top {
    height: 45px;
    width: 100%;
    margin-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue